import React from 'react';
export function AnnouncementBar() {
  return <aside className="sticky top-0 z-50 flex min-h-[32px] w-full items-center justify-center bg-brand-navy px-3 py-[7px] text-center text-white" data-id="element-17" data-mp="2tgqpao3xs0lk">
      <p className="text-[10px] font-extrabold leading-tight tracking-[0.1em] sm:text-[11px]" data-id="element-18" data-mp="jtk116wp6chf">
        LIMITED-TIME LAUNCH OFFER — GET THE COMPLETE PE READY SYSTEM TODAY
      </p>
    </aside>;
}